import {useEffect, useState} from 'react'
import {connect, useDispatch, useSelector} from 'react-redux'
import {base_url} from '../../../Utils/constants'
import * as Sentry from '@sentry/react'
import {setContext} from '@sentry/react'

import {_formatPrice, getHash} from '../../../Utils/tools'
import {
  createPurchaseOrder,
  getConfigPage,
  getConfigSite,
  suraConfirmation,
} from '../../../Utils/api'
import {removeShoppingCart} from '../../../Utils/service'
import imgResultError from '../../../assets/img/i_error.svg'
import imgResultNew from '../../../assets/img/i_success_new.svg'
import loadingYapp from '../../../assets/img/yapp_loading.gif'
import {
  setThemeColor,
  changeLogo,
  showLogo,
  setConfig,
  setGoRouter,
} from '../../../redux/modules/app'
import {
  addEventNameWithParams,
  logEvent,
  downloadApp,
} from '../../../Utils/utils'
import ButtonYapp from '../../../Components/Buttons/ButtonYapp'

const _ = require('lodash')

function ShoppingBagCheckout(props) {
  const [statusOrder, setStatusOrder] = useState(null)

  const applicationNumber = useSelector((state) => state.app.applicationNumber)
  const prescriptions = useSelector((state) => state.app.prescriptions)
  const onePharmacy = useSelector((state) => state.app.one_pharmacy)

  const dispatch = useDispatch()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      if (process.env.REACT_APP_CLIENT_NAME === 'UC Christus') {
        let router = []
        dispatch(props.setGoRouter(router))
      }
    } catch (ignore) {}

    let hash = null
    try {
      hash = getHash()
    } catch (ignore) {}

    if (props.disabledThemeCheckout === true) {
      dispatch(changeLogo(null))
      dispatch(showLogo(false))
      dispatch(
        setThemeColor({
          icon_tutorial: '#282E55',
          primary: '#6578FF',
          secondary: '#DF901E',
        }),
      )
    } else {
      if (hash) {
        try {
          let result =
            process.env.REACT_APP_ON_LOGIN === 'TRUE' ||
            process.env.REACT_APP_PROFILE === 'INSURANCE' ||
            (process.env.REACT_APP_EXTERNAL_LOGIN === 'TRUE' &&
              [undefined, null, 'NULL'].includes(
                process.env.REACT_APP_EXTERNAL_VALID_TYPE,
              ))
              ? await getConfigSite()
              : await getConfigPage(hash)

          if (result) {
            const themeColor =
              result?.data.config[0].config?.custom_styles?.theme_color

            dispatch(
              showLogo(_.get(result?.data, 'config[0].config.show_logo', true)),
            )
            dispatch(changeLogo(_.get(result?.data, 'config[0].config.logo')))
            if (themeColor) {
              dispatch(setThemeColor(themeColor))
            }
            dispatch(setConfig(_.get(result?.data, 'config[0].config', {})))
          }
        } catch (ignore) {}
      }
    }

    let purchaseOrderStatus = 'declined'
    let purchaseOrder = localStorage.getItem('selectedQuotationItem')
    try {
      if (purchaseOrder) purchaseOrder = JSON.parse(purchaseOrder)
    } catch (error) {
      purchaseOrder = false
    }

    try {
      let resp = await createPurchaseOrder(hash)
      if (
        resp?.data?.status === 'approvedTransaction' ||
        resp?.data?.status === 'preApprovedTransaction'
      ) {
        purchaseOrderStatus = resp.data.status
      }

      if (purchaseOrderStatus !== 'declined') {
        addEventNameWithParams('checkout_product_to_pay_result', {
          hash: hash,
          status: purchaseOrderStatus,
        })
        await savePurchaseOrderTag(purchaseOrder, resp.data.id)
        if (
          ['preApprovedTransaction', 'approvedTransaction'].includes(
            purchaseOrderStatus,
          )
        ) {
          setStatusOrder(true)
          await removeShoppingCart()
          if (applicationNumber) {
            let response = await suraConfirmation({
              applicationNumber,
              prescriptions,
              purchaseId: resp.data.id,
            })
            try {
              if (response?.data?.codError !== 0) {
                setContext('Error Sura', {data: JSON.stringify(response.data)})
                Sentry.captureMessage('Error Refund Checked')
              }
            } catch (ignore) {}
          }

          localStorage.removeItem('selectedQuotationItem')
        } else {
          window.location.href = base_url + '/shopping_bag/post_shopping'
        }
      } else {
        setStatusOrder(false)
        addEventNameWithParams('checkout_product_to_pay_result', {
          hash: hash,
          status: purchaseOrderStatus,
        })
        await savePurchaseOrderTag(purchaseOrder, false)
      }
    } catch (error) {
      console.log(error)
      setStatusOrder(false)
      await savePurchaseOrderTag(purchaseOrder, false)
      if (hash) {
        addEventNameWithParams('checkout_product_to_pay_result', {
          hash: hash,
          status: purchaseOrderStatus,
        })
      }
    }
  }, [])

  const savePurchaseOrderTag = async (purchaseOrder, result) => {
    let success = result ? true : false
    let productQuantity = 0
    let totalPrice = 0

    if (purchaseOrder?.quotation_detail?.length > 0) {
      let productList = purchaseOrder.quotation_detail

      let refundable = 'FALSE'
      for (const product of productList) {
        productQuantity += product.quantity
        totalPrice += product.quantity * product.price

        if (success) {
          let refundableProduct =
            process.env.REACT_APP_PROFILE === 'INSURANCE' &&
            ![null, undefined].includes(product.id)
              ? 'TRUE'
              : 'FALSE'
          if (refundableProduct === 'TRUE') {
            refundable = 'TRUE'
          }
          logEvent('Product Purchased', {
            'Product Quantity': product.quantity,
            'Order Id': result ? result : 0,
            'Product Name': product.product.name,
            'Product Id': product.product.product_id,
            'Lab Name': product.product.lab,
            'Product Price': product.price,
            'Total Price': product.quantity * product.price,
            'Total Discounts': 0,
            'Active Principle Name': product.product.formula_name,
            'Refundable Product': refundableProduct,
          })
        }
      }

      logEvent('Order Completed', {
        'Order Success': success,
        'Total Cart Value': totalPrice,
        'Total Cart Size': productQuantity,
        'Total Discounts': 0,
        'Promo Code Applied': null,
        'Total Shipping': purchaseOrder.delivery.cost,
        'Order Total': totalPrice + purchaseOrder.delivery.cost,
        'Pharmacy Id': purchaseOrder.pharmacy_chain_id,
        'Pharmacy Name': purchaseOrder.pharmacy_chain_name,
        'Order Id': result ? result : 0,
        'Purchase Type': 'Spot',
        'Refundable Order': refundable,
      })
    }
  }

  return (
    <div className="flex-grow-1 content-responsive mx-auto mb-5">
      {![undefined, null].includes(statusOrder) ? (
        <>
          <div className="px-3 px-md-0">
            <div className="maxw-300 card-messege my-5 mx-auto">
              <h4 className={`txt-1--bold-db mb-3 text-center`}>
                {statusOrder
                  ? '¡Hemos procesado tu pedido con éxito!'
                  : 'No hemos procesado tu pedido con éxito...'}
              </h4>
              <img
                id={
                  statusOrder
                    ? 'gtm-webapp-checkout-result-img-success'
                    : 'gtm-webapp-checkout-result-img-error'
                }
                src={statusOrder ? imgResultNew : imgResultError}
                alt="Success"
                className="mb-4 img-message"
              />
              {statusOrder && (
                <>
                  <p className={'txt-paragraph text-center line-14'}>
                    Te hemos enviado un correo para que le hagas seguimiento a
                    tu pedido.
                  </p>
                </>
              )}
              {statusOrder && (
                <>
                  {![undefined, null, false].includes(onePharmacy) && (
                    <>
                      <p className="txt-paragraph text-center mt-3">
                        <span className="txt-paragraph--bold">
                          *La farmacia revisará la validez de los documentos
                        </span>
                      </p>
                      <p className="txt-paragraph text-center">
                        <span className="txt-paragraph--bold">
                          de vecino/a de {process.env.REACT_APP_CLIENT_NAME}.
                        </span>{' '}
                        Si no están correctos,
                      </p>
                      <p className="txt-paragraph text-center">
                        pueden rechazar el pedido y generaremos la
                      </p>
                      <p className="txt-paragraph text-center">
                        devolución del dinero.
                      </p>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center  mb-4">
            <p className="title-primary--regular text-center maxw-250">
              ¿Te gustaría cotizar tus medicamentos
              <br /> siempre antes de comparlos? ¡Descarga
              <br /> nuestra app en tu celular!
            </p>
          </div>
          <div className="d-flex w-100 justify-content-center pt-2">
            <ButtonYapp
              id="gtm-webapp-checkout-result-btn-download"
              className="mx-auto px-2"
              disabled={false}
              title={'Descargar yapp'}
              color={'--theme-color'}
              onClick={downloadApp}
              small
            />
          </div>
        </>
      ) : (
        <div className="d-flex justify-content-center w-100 py-5">
          <img src={loadingYapp} alt="loading" height={70} />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    disabledThemeCheckout: state.app.config?.disabled_theme_checkout,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setGoRouter: (router) => dispatch(setGoRouter(router)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ShoppingBagCheckout)
